const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Simple Harmonic Motion — displacement, velocity, acceleration ──
function DiagramSHM() {
  const W = 860, H = 380;
  const pts_x = [], pts_v = [], pts_a = [];
  const cycles = 2;
  for (let i = 0; i <= 600; i += 3) {
    const t = (i / 600) * cycles * Math.PI * 2;
    pts_x.push(`${i + 120},${100 + 55 * Math.cos(t)}`);
    pts_v.push(`${i + 120},${220 + 55 * (-Math.sin(t))}`);
    pts_a.push(`${i + 120},${340 + 45 * (-Math.cos(t))}`);
  }
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Simple Harmonic Motion — Displacement, Velocity and Acceleration vs Time</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="shmArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#555" />
          </marker>
        </defs>

        {/* Axes and labels */}
        {[
          { y:100, color:'#2E75B6', label:'x (displacement)',  pts: pts_x },
          { y:220, color:'#27ae60', label:'v (velocity)',       pts: pts_v },
          { y:340, color:'#c0392b', label:'a (acceleration)',   pts: pts_a },
        ].map(({ y, color, label, pts }) => (
          <g key={label}>
            <line x1={118} y1={y} x2={740} y2={y} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3" />
            <path d={'M ' + pts.join(' L ')} fill="none" stroke={color} strokeWidth="2.2" />
            <text x={112} y={y + 4} fontSize="10" textAnchor="end" fill={color} fontWeight="700">{label}</text>
          </g>
        ))}

        {/* Phase annotations */}
        <text x={120} y={20} fontSize="10" fill="#555" fontStyle="italic">t = 0: max displacement, zero velocity, max acceleration (opposite)</text>
        <line x1={120} y1={44} x2={120} y2={370} stroke="#aaa" strokeWidth="1" strokeDasharray="3,3" />
        <line x1={420} y1={44} x2={420} y2={370} stroke="#aaa" strokeWidth="1" strokeDasharray="3,3" />
        <line x1={720} y1={44} x2={720} y2={370} stroke="#aaa" strokeWidth="1" strokeDasharray="3,3" />
        <text x={267} y={375} textAnchor="middle" fontSize="10" fill="#555">T  (one period)</text>
        <line x1={120} y1={368} x2={420} y2={368} stroke="#555" strokeWidth="1" markerEnd="url(#shmArr)" />

        {/* Key labels */}
        <text x={760} y={104} fontSize="10" fill="#2E75B6" fontWeight="700">A</text>
        <text x={760} y={58} fontSize="10" fill="#2E75B6">+A</text>
        <text x={760} y={148} fontSize="10" fill="#2E75B6">−A</text>
        <text x={760} y={224} fontSize="10" fill="#27ae60">v_max</text>
        <text x={760} y={344} fontSize="10" fill="#c0392b">−ω²A</text>
      </svg>
      <div style={S.dCaption}>
        In SHM, acceleration is always directed toward the equilibrium and proportional to displacement: a = −ω²x. Velocity leads displacement by 90° (π/2); acceleration is exactly anti-phase with displacement (180°).
      </div>
    </div>
  );
}

// ── Diagram 2: Simple Pendulum and Mass-Spring ────────────────────
function DiagramOscillators() {
  const W = 860, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Two Classic SHM Systems — Simple Pendulum and Mass-Spring</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* ── Pendulum ── */}
        <rect x={20} y={20} width={380} height={285} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={210} y={44} textAnchor="middle" fontSize="13" fontWeight="700" fill="#2E75B6">Simple Pendulum</text>

        {/* Pivot */}
        <rect x={195} y={55} width={30} height={10} rx={3} fill="#555" />
        {/* Equilibrium string + bob */}
        <line x1={210} y1={65} x2={210} y2={195} stroke="#888" strokeWidth="2" strokeDasharray="4,3" />
        <circle cx={210} cy={208} r={14} fill="#2E75B6" opacity="0.85" />
        {/* Displaced string + bob */}
        <line x1={210} y1={65} x2={270} y2={180} stroke="#1a3a6e" strokeWidth="2" />
        <circle cx={270} cy={192} r={14} fill="#1a3a6e" opacity="0.7" />
        {/* Angle arc */}
        <path d="M 210,65 m 0,40 a 40,40 0 0,1 24,-20" fill="none" stroke="#c0392b" strokeWidth="1.5" />
        <text x={238} y={100} fontSize="11" fill="#c0392b" fontWeight="700">θ</text>
        {/* Length label */}
        <text x={215} y={140} fontSize="10" fill="#2E75B6" fontWeight="700">L</text>
        {/* Arc of motion */}
        <path d="M 150,192 Q 210,240 270,192" fill="none" stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3" />

        {/* Formula box */}
        <rect x={35} y={235} width={355} height={55} rx={4} fill="#fff" stroke="#2E75B6" strokeWidth="1" />
        <text x={213} y={254} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e">T = 2π √(L/g)</text>
        <text x={213} y={270} textAnchor="middle" fontSize="10" fill="#555">Independent of mass and amplitude (small angles)</text>
        <text x={213} y={283} textAnchor="middle" fontSize="10" fill="#555">ω = √(g/L)   f = (1/2π)√(g/L)</text>

        {/* ── Mass-Spring ── */}
        <rect x={440} y={20} width={400} height={285} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={640} y={44} textAnchor="middle" fontSize="13" fontWeight="700" fill="#c0392b">Mass-Spring System</text>

        {/* Ceiling */}
        <rect x={590} y={55} width={100} height={10} rx={3} fill="#555" />
        {/* Spring coils */}
        {Array.from({ length: 10 }).map((_, i) => {
          const y1 = 65 + i * 10;
          const y2 = 65 + (i + 1) * 10;
          const xOff = (i % 2 === 0) ? 8 : -8;
          return <line key={i} x1={640} y1={y1} x2={640 + xOff} y2={y2} stroke="#c0392b" strokeWidth="2" />;
        })}
        {/* Mass block */}
        <rect x={614} y={165} width={52} height={38} rx={4} fill="#c0392b" opacity="0.85" />
        <text x={640} y={189} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">m</text>
        {/* Extension label */}
        <line x1={700} y1={65} x2={700} y2={165} stroke="#aaa" strokeWidth="1.5" strokeDasharray="4,3" />
        <text x={706} y={120} fontSize="10" fill="#c0392b" fontWeight="700">x</text>
        {/* Restoring force arrow */}
        <line x1={640} y1={203} x2={640} y2={240} stroke="#27ae60" strokeWidth="2.5" />
        <polygon points="634,238 640,252 646,238" fill="#27ae60" />
        <text x={648} y={238} fontSize="10" fill="#27ae60" fontWeight="700">F = −kx</text>

        {/* Formula box */}
        <rect x={455} y={235} width={370} height={55} rx={4} fill="#fff" stroke="#c0392b" strokeWidth="1" />
        <text x={640} y={254} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e">T = 2π √(m/k)</text>
        <text x={640} y={270} textAnchor="middle" fontSize="10" fill="#555">Independent of amplitude; increases with mass, decreases with stiffness</text>
        <text x={640} y={283} textAnchor="middle" fontSize="10" fill="#555">ω = √(k/m)   f = (1/2π)√(k/m)</text>
      </svg>
      <div style={S.dCaption}>
        Both systems obey a = −ω²x. The pendulum's restoring force is the component of gravity along the arc; the spring's is Hooke's Law. Both periods are amplitude-independent for small oscillations.
      </div>
    </div>
  );
}

// ── Diagram 3: Energy in SHM ──────────────────────────────────────
function DiagramSHMEnergy() {
  const W = 860, H = 300;
  const ptsKE = [], ptsPE = [], ptsTot = [];
  for (let i = 0; i <= 680; i += 4) {
    const t = (i / 680) * 2 * Math.PI * 2;
    const ke = 60 * Math.pow(Math.sin(t), 2);
    const pe = 60 * Math.pow(Math.cos(t), 2);
    ptsKE.push(`${i + 90},${220 - ke}`);
    ptsPE.push(`${i + 90},${220 - pe}`);
    ptsTot.push(`${i + 90},${220 - 60}`);
  }
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Energy in SHM — Kinetic, Potential and Total Energy vs Displacement</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {/* Axes */}
        <line x1={90} y1={30} x2={90} y2={230} stroke="#555" strokeWidth="1.5" />
        <line x1={90} y1={230} x2={780} y2={230} stroke="#555" strokeWidth="1.5" />
        <text x={82} y={34} fontSize="10" textAnchor="end" fill="#555">E</text>
        <text x={782} y={234} fontSize="10" fill="#555">t</text>
        <text x={86} y={163} fontSize="10" textAnchor="end" fill="#555">½E</text>
        <line x1={88} y1={160} x2={780} y2={160} stroke="#eee" strokeWidth="1" strokeDasharray="4,3" />

        {/* Curves */}
        <path d={'M ' + ptsKE.join(' L ')} fill="none" stroke="#27ae60" strokeWidth="2.5" />
        <path d={'M ' + ptsPE.join(' L ')} fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <path d={'M ' + ptsTot.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2" strokeDasharray="8,4" />

        {/* Legend */}
        <line x1={110} y1={260} x2={145} y2={260} stroke="#27ae60" strokeWidth="2.5" />
        <text x={150} y={264} fontSize="11" fill="#27ae60" fontWeight="700">Kinetic energy  EK = ½mω²(A²−x²)</text>
        <line x1={430} y1={260} x2={465} y2={260} stroke="#c0392b" strokeWidth="2.5" />
        <text x={470} y={264} fontSize="11" fill="#c0392b" fontWeight="700">Potential energy  EP = ½mω²x²</text>
        <line x1={110} y1={280} x2={145} y2={280} stroke="#2E75B6" strokeWidth="2" strokeDasharray="8,4" />
        <text x={150} y={284} fontSize="11" fill="#2E75B6" fontWeight="700">Total energy  E = ½mω²A²  (constant)</text>

        {/* Annotation */}
        <text x={435} y={20} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">KE and PE are always in anti-phase; their sum is constant (no damping)</text>
      </svg>
      <div style={S.dCaption}>
        At maximum displacement (x = ±A), all energy is potential and KE = 0. At equilibrium (x = 0), all energy is kinetic and PE = 0. Total mechanical energy E = ½mω²A² — proportional to the square of amplitude.
      </div>
    </div>
  );
}

// ── Diagram 4: Damped Oscillations ───────────────────────────────
function DiagramDamping() {
  const W = 860, H = 320;

  function dampedPts(gamma, yBase, amp) {
    const pts = [];
    for (let i = 0; i <= 680; i += 3) {
      const t = i / 80;
      const y = yBase + amp * Math.exp(-gamma * t) * Math.cos(t * 3.5);
      pts.push(`${i + 90},${y}`);
    }
    return pts;
  }

  const lightPts   = dampedPts(0.08,  80, 55);
  const heavyPts   = dampedPts(0.30, 195, 55);
  const critPts    = [];
  for (let i = 0; i <= 680; i += 3) {
    const t = i / 80;
    const y = 300 + 55 * (1 + t * 1.2) * Math.exp(-t * 1.35);
    critPts.push(`${i + 90},${y}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Damped Oscillations — Light, Heavy and Critical Damping</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Equilibrium lines */}
        <line x1={90} y1={80}  x2={775} y2={80}  stroke="#ddd" strokeWidth="1" strokeDasharray="4,3" />
        <line x1={90} y1={195} x2={775} y2={195} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3" />
        <line x1={90} y1={300} x2={775} y2={300} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3" />

        {/* Waves */}
        <path d={'M ' + lightPts.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.2" />
        <path d={'M ' + heavyPts.join(' L ')} fill="none" stroke="#e67e22" strokeWidth="2.2" />
        <path d={'M ' + critPts.join(' L ')}  fill="none" stroke="#27ae60" strokeWidth="2.2" />

        {/* Envelope for light damping */}
        {(() => {
          const upper = [], lower = [];
          for (let i = 0; i <= 680; i += 4) {
            const t = i / 80;
            const env = 55 * Math.exp(-0.08 * t);
            upper.push(`${i+90},${80-env}`);
            lower.push(`${i+90},${80+env}`);
          }
          return (
            <>
              <path d={'M ' + upper.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="1" strokeDasharray="5,3" opacity="0.5" />
              <path d={'M ' + lower.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="1" strokeDasharray="5,3" opacity="0.5" />
            </>
          );
        })()}

        {/* Labels */}
        <text x={780} y={84}  fontSize="11" fill="#2E75B6" fontWeight="700">Light</text>
        <text x={780} y={199} fontSize="11" fill="#e67e22" fontWeight="700">Heavy</text>
        <text x={780} y={304} fontSize="11" fill="#27ae60" fontWeight="700">Critical</text>

        <text x={90} y={20} fontSize="10" fill="#555" fontStyle="italic">Light damping: amplitude decays exponentially but oscillations persist</text>
        <text x={90} y={34} fontSize="10" fill="#555" fontStyle="italic">Heavy/overdamping: system returns to equilibrium without oscillating</text>
        <text x={90} y={48} fontSize="10" fill="#555" fontStyle="italic">Critical damping: fastest return to equilibrium without overshoot</text>
      </svg>
      <div style={S.dCaption}>
        The dashed lines show the exponential decay envelope: x_max = Ae^(−γt). Critical damping is used in car suspension and door closers — it prevents oscillation while returning to equilibrium as fast as possible.
      </div>
    </div>
  );
}

// ── Diagram 5: Resonance Curve ────────────────────────────────────
function DiagramResonance() {
  const W = 860, H = 300;

  function resonanceCurve(Q, color, label) {
    const pts = [];
    const f0 = 300;
    for (let f = 50; f <= 600; f += 4) {
      const denom = Math.sqrt(Math.pow(f0*f0 - f*f, 2) + Math.pow(f0*f/Q, 2));
      const amp = (f0 * f0 / denom) * 45;
      const capped = Math.min(amp, 210);
      pts.push(`${(f-50)/550*640 + 80},${250 - capped}`);
    }
    return { pts, color, label };
  }

  const curves = [
    resonanceCurve(2,   '#e67e22', 'Low Q (heavy damping)'),
    resonanceCurve(6,   '#2E75B6', 'Medium Q'),
    resonanceCurve(20,  '#c0392b', 'High Q (light damping)'),
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Forced Oscillations and Resonance — Amplitude vs Driving Frequency</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="resArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#555" />
          </marker>
        </defs>

        {/* Axes */}
        <line x1={80} y1={250} x2={730} y2={250} stroke="#555" strokeWidth="1.5" markerEnd="url(#resArr)" />
        <line x1={80} y1={250} x2={80}  y2={25}  stroke="#555" strokeWidth="1.5" markerEnd="url(#resArr)" />
        <text x={734} y={254} fontSize="11" fill="#555">f (driving frequency)</text>
        <text x={84}  y={22}  fontSize="11" fill="#555">Amplitude</text>

        {/* Natural frequency marker */}
        <line x1={370} y1={248} x2={370} y2={30} stroke="#aaa" strokeWidth="1" strokeDasharray="5,3" />
        <text x={370} y={268} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">f₀ (natural frequency)</text>

        {/* Curves */}
        {curves.map(({ pts, color, label }) => (
          <path key={label} d={'M ' + pts.join(' L ')} fill="none" stroke={color} strokeWidth="2.2" />
        ))}

        {/* Legend */}
        {curves.map(({ color, label }, i) => (
          <g key={i}>
            <line x1={460} y1={30 + i*22} x2={490} y2={30 + i*22} stroke={color} strokeWidth="2.2" />
            <text x={495} y={34 + i*22} fontSize="10" fill={color} fontWeight="700">{label}</text>
          </g>
        ))}

        {/* Bandwidth annotation */}
        <line x1={330} y1={170} x2={410} y2={170} stroke="#2E75B6" strokeWidth="1.5" />
        <text x={370} y={163} textAnchor="middle" fontSize="10" fill="#2E75B6">Bandwidth Δf = f₀/Q</text>
      </svg>
      <div style={S.dCaption}>
        At resonance (f_drive = f₀), amplitude is maximum. Higher Q means sharper, taller resonance peak and narrower bandwidth. Real systems always have some damping which limits the resonant amplitude.
      </div>
    </div>
  );
}

// ── Diagram 6: Transverse vs Longitudinal ────────────────────────
function DiagramWaveTypes() {
  const W = 860, H = 280;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wave Types — Transverse and Longitudinal</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Transverse */}
        <rect x={15} y={15} width={400} height={250} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={215} y={38} textAnchor="middle" fontSize="13" fontWeight="700" fill="#2E75B6">Transverse Wave</text>

        {/* Sine curve */}
        {(() => {
          const pts = [];
          for (let x = 0; x <= 360; x += 4) {
            pts.push(`${x + 30},${130 + 55 * Math.sin((x / 360) * Math.PI * 4)}`);
          }
          return <path d={'M ' + pts.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.5" />;
        })()}

        {/* Arrows showing particle motion (vertical) */}
        {[45, 105, 165, 225, 285, 345].map((x, i) => {
          const y = 130 + 55 * Math.sin(((x-30) / 360) * Math.PI * 4);
          return <line key={i} x1={x} y1={y} x2={x} y2={y > 130 ? y - 20 : y + 20}
            stroke="#c0392b" strokeWidth="1.5"
            markerEnd="url(#tArr)" opacity="0.7" />;
        })}
        <text x={215} y={210} textAnchor="middle" fontSize="10" fill="#555">↕ Particle motion</text>
        <text x={215} y={225} textAnchor="middle" fontSize="10" fill="#555">→ Wave propagation</text>
        <text x={215} y={250} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Examples: light, water surface, strings, seismic S-waves</text>

        {/* Longitudinal */}
        <rect x={440} y={15} width={405} height={250} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={642} y={38} textAnchor="middle" fontSize="13" fontWeight="700" fill="#c0392b">Longitudinal Wave</text>

        {/* Molecules with displacement */}
        {Array.from({ length: 24 }).map((_, i) => {
          const baseX = 455 + i * 15;
          const phase = (i / 24) * Math.PI * 4;
          const dx = 6 * Math.sin(phase);
          const density = 0.5 + 0.5 * Math.cos(phase);
          const r = 5 + density * 2;
          const blue = Math.round(80 + density * 140);
          const fill = `rgb(${Math.round(180 - density*120)},${Math.round(60 + density*40)},${blue})`;
          return (
            <g key={i}>
              <circle cx={baseX + dx} cy={130} r={r} fill={fill} opacity="0.8" />
              <line x1={baseX} y1={155} x2={baseX + dx} y2={155}
                stroke="#c0392b" strokeWidth="1" opacity="0.5" />
            </g>
          );
        })}
        <text x={642} y={210} textAnchor="middle" fontSize="10" fill="#555">↔ Particle motion (parallel to propagation)</text>
        <text x={642} y={225} textAnchor="middle" fontSize="10" fill="#555">→ Wave propagation</text>
        <text x={642} y={250} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Examples: sound, seismic P-waves, ultrasound</text>

        <defs>
          <marker id="tArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b" />
          </marker>
        </defs>
      </svg>
      <div style={S.dCaption}>
        The key distinction: in transverse waves, particle displacement is perpendicular to wave travel; in longitudinal waves it is parallel. Only transverse waves can be polarised.
      </div>
    </div>
  );
}

// ── Diagram 7: Phasor Representation ─────────────────────────────
function DiagramPhasor() {
  const W = 860, H = 300;
  const angle1 = -Math.PI / 6;
  const angle2 = angle1 + Math.PI / 2;
  const cx1 = 160, cy1 = 155, R = 80;
  const cx2 = 520, cy2 = 155;

  const x1 = cx1 + R * Math.cos(angle1);
  const y1 = cy1 + R * Math.sin(angle1);
  const x2 = cx2 + R * Math.cos(angle2);
  const y2 = cy2 + R * Math.sin(angle2);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Phasor Diagrams — Representing Oscillations as Rotating Vectors</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="phArr" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#2E75B6" />
          </marker>
          <marker id="phArr2" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#c0392b" />
          </marker>
        </defs>

        {/* Phasor 1 */}
        <rect x={30} y={20} width={270} height={265} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={165} y={42} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">Phasor at angle ωt</text>
        <circle cx={cx1} cy={cy1} r={R} fill="none" stroke="#aaa" strokeWidth="1" strokeDasharray="5,3" />
        <line x1={cx1} y1={cy1} x2={x1} y2={y1} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#phArr)" />
        {/* Projection onto y-axis */}
        <line x1={x1} y1={y1} x2={cx1} y2={y1} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="4,3" />
        <line x1={cx1} y1={cy1-R} x2={cx1} y2={cy1+R} stroke="#555" strokeWidth="1" />
        <circle cx={cx1} cy={y1} r={4} fill="#c0392b" />
        <text x={cx1 - 18} y={y1 + 4} fontSize="10" fill="#c0392b" textAnchor="end">x = A sinωt</text>
        <text x={x1 + 8} y={cy1 + 4} fontSize="10" fill="#2E75B6">A</text>
        {/* Angle label */}
        <path d={`M ${cx1+20},${cy1} A 20,20 0 0,0 ${cx1 + 20*Math.cos(angle1)},${cy1 + 20*Math.sin(angle1)}`} fill="none" stroke="#555" strokeWidth="1" />
        <text x={cx1 + 25} y={cy1 - 8} fontSize="10" fill="#555">ωt</text>
        <text x={165} y={270} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Phasor rotates anticlockwise at angular frequency ω</text>

        {/* Phasor 2 — two phasors showing phase difference */}
        <rect x={330} y={20} width={510} height={265} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={585} y={42} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">Two Phasors — Phase Difference φ = π/2</text>
        <circle cx={cx2} cy={cy2} r={R} fill="none" stroke="#aaa" strokeWidth="1" strokeDasharray="5,3" />
        {/* Phasor A */}
        <line x1={cx2} y1={cy2} x2={x1 + 360} y2={y1} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#phArr)" />
        {/* Phasor B (90 deg ahead) */}
        <line x1={cx2} y1={cy2} x2={cx2 + R * Math.cos(angle2)} y2={cy2 + R * Math.sin(angle2)} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#phArr2)" />
        {/* Phase arc */}
        <path d={`M ${cx2 + 28},${cy2} A 28,28 0 0,0 ${cx2 + 28*Math.cos(angle2)},${cy2 + 28*Math.sin(angle2)}`} fill="none" stroke="#555" strokeWidth="1.2" />
        <text x={cx2 + 32} y={cy2 - 14} fontSize="10" fill="#555">φ = π/2</text>
        <text x={cx2 + R + 6} y={y1 + 2} fontSize="10" fill="#2E75B6" fontWeight="700">x₁</text>
        <text x={cx2 + R*Math.cos(angle2) + 6} y={cy2 + R*Math.sin(angle2) + 4} fontSize="10" fill="#c0392b" fontWeight="700">x₂</text>

        {/* Resultant */}
        <line x1={cx2} y1={cy2}
          x2={cx2 + R*Math.cos(angle1) + R*Math.cos(angle2)}
          y2={cy2 + R*Math.sin(angle1) + R*Math.sin(angle2)}
          stroke="#27ae60" strokeWidth="2" strokeDasharray="6,3" />
        <text x={780} y={120} fontSize="10" fill="#27ae60" fontWeight="700">Resultant</text>
        <text x={585} y={270} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Phasors add as vectors; resultant gives amplitude and phase of combined oscillation</text>
      </svg>
      <div style={S.dCaption}>
        A phasor is a rotating vector whose length represents amplitude and whose angle represents phase. The projection onto the vertical axis gives the instantaneous displacement. Phasors make adding oscillations of the same frequency straightforward.
      </div>
    </div>
  );
}

// ── Diagram 8: Polarisation ───────────────────────────────────────
function DiagramPolarisation() {
  const W = 860, H = 280;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Polarisation — Transverse Waves Only</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Unpolarised beam */}
        <rect x={15} y={15} width={240} height={250} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={135} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#2E75B6">Unpolarised Light</text>
        {/* Many directions */}
        {[0,30,60,90,120,150].map((deg, i) => {
          const rad = deg * Math.PI / 180;
          const dx = 35 * Math.cos(rad), dy = 35 * Math.sin(rad);
          return (
            <g key={i}>
              <line x1={135 - dx} y1={140 - dy} x2={135 + dx} y2={140 + dy} stroke="#2E75B6" strokeWidth="1.8" opacity="0.7" />
            </g>
          );
        })}
        <text x={135} y={250} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Vibrations in all planes</text>

        {/* Polariser */}
        <rect x={270} y={70} width={22} height={145} rx={4} fill="#888" />
        <text x={281} y={234} textAnchor="middle" fontSize="10" fill="#555">Polariser</text>
        {[75,95,115,135,155,175,195].map((y,i) => (
          <line key={i} x1={275} y1={y} x2={287} y2={y} stroke="#eee" strokeWidth="1.5" />
        ))}

        {/* Polarised beam */}
        <rect x={310} y={15} width={240} height={250} rx={8} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5" />
        <text x={430} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#27ae60">Plane Polarised</text>
        {[115,130,145,160,175].map((y, i) => (
          <line key={i} x1={330} y1={y} x2={530} y2={y} stroke="#27ae60" strokeWidth="1.8" opacity="0.7" />
        ))}
        <text x={430} y={250} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Vibrations in one plane only</text>

        {/* Second analyser — crossed */}
        <rect x={565} y={70} width={22} height={145} rx={4} fill="#888" />
        <text x={576} y={234} textAnchor="middle" fontSize="10" fill="#555">Analyser</text>
        {[75,95,115,135,155,175,195].map((y,i) => {
          const cx = 276, cy = y;
          return <line key={i} x1={570} y1={y - 7} x2={582} y2={y + 7} stroke="#eee" strokeWidth="1.5" />;
        })}

        {/* Blocked */}
        <rect x={605} y={15} width={240} height={250} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={725} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#c0392b">Crossed Polarisers</text>
        <text x={725} y={140} textAnchor="middle" fontSize="28" fill="#c0392b" opacity="0.6">✕</text>
        <text x={725} y={170} textAnchor="middle" fontSize="11" fill="#c0392b">No transmission</text>
        <text x={725} y={250} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Analyser axis ⊥ polariser: I = 0</text>

        {/* Malus law box */}
        <rect x={310} y={195} width={240} height={50} rx={4} fill="#fff" stroke="#27ae60" strokeWidth="1" />
        <text x={430} y={215} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e">Malus's Law: I = I₀ cos²θ</text>
        <text x={430} y={232} textAnchor="middle" fontSize="10" fill="#555">θ = angle between polariser axes</text>
      </svg>
      <div style={S.dCaption}>
        Only transverse waves can be polarised — this is an experimental proof that light is transverse. Polarising filters, LCD screens, sunglasses, and stress analysis all rely on polarisation. Longitudinal waves (sound) cannot be polarised.
      </div>
    </div>
  );
}

export default function OscillationsWaves() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Oscillations and Waves</h1>

      <p style={S.p}>
        Oscillations and waves are among the most universal phenomena in physics. From the swinging of a pendulum to the propagation of light across the universe, from the vibration of atoms in a crystal to the ripples on a pond — the mathematics of periodic motion and wave propagation underpins mechanics, electromagnetism, quantum mechanics, and optics. Understanding these topics provides the foundation for almost every area of modern physics and engineering.
      </p>
      <p style={S.p}>
        An <strong>oscillation</strong> is any motion that repeats periodically about an equilibrium position. When the restoring force is proportional to the displacement, the motion is called <strong>Simple Harmonic Motion (SHM)</strong> — the idealised model studied in this topic. A <strong>wave</strong> is a disturbance that transfers energy through a medium (or through a field) without transferring matter. Oscillations and waves are intimately connected: a wave can be thought of as a spatially distributed oscillation.
      </p>
      <p style={S.p}>
        This page covers the mathematical description of SHM, energy considerations, damping, forced oscillations and resonance, the nature of progressive and stationary waves, polarisation, the electromagnetic spectrum, and the mathematical treatment of wave superposition — including coherence and path difference.
      </p>

      <InfoBox title="What This Page Covers" items={[
        "Simple Harmonic Motion: definition, equations, phase relationships",
        "SHM systems: pendulum, mass-spring, torsional and LC oscillators",
        "Energy in SHM: kinetic, potential, total — and amplitude dependence",
        "Damped oscillations: light, heavy, critical and overdamping",
        "Forced oscillations, resonance curves, and quality factor Q",
        "Progressive waves: transverse vs longitudinal, wave equation",
        "Polarisation and Malus's Law",
        "Phasor representation of oscillations",
        "Superposition, coherence, path difference and phase difference",
        "The electromagnetic spectrum: full range and properties",
        "Wave intensity and the inverse square law",
        "Coupled oscillators and normal modes",
      ]}/>

      <h2 style={S.h2}>Simple Harmonic Motion — Definition and Equations</h2>
      <p style={S.p}>
        Simple Harmonic Motion is defined as oscillatory motion in which the acceleration is directly proportional to displacement from equilibrium and always directed toward it. This single condition, <strong>a = −ω²x</strong>, generates sinusoidal motion and governs a vast range of physical systems — from atomic vibrations to AC circuits to gravitational waves.
      </p>
      <DiagramSHM/>
      <Table2 rows={[
        ["Defining condition","a = −ω²x\nAcceleration proportional to displacement, directed toward equilibrium"],
        ["Displacement","x = A cos(ωt + φ)  or  x = A sin(ωt + φ)\nA = amplitude (m), ω = angular frequency (rad/s), φ = initial phase (rad)"],
        ["Velocity","v = dx/dt = −Aω sin(ωt + φ)\nMaximum speed v_max = Aω  at equilibrium (x = 0)"],
        ["Acceleration","a = d²x/dt² = −Aω² cos(ωt + φ) = −ω²x\nMaximum at x = ±A; zero at x = 0"],
        ["Angular frequency","ω = 2πf = 2π/T  (rad/s)\nLinks oscillation rate to the equations of motion"],
        ["Speed at displacement x","v = ω√(A² − x²)\nUseful when time is not known; v = 0 at x = ±A"],
        ["Period T","T = 1/f = 2π/ω  (seconds)\nTime for one complete oscillation — independent of amplitude in ideal SHM"],
        ["Phase difference","Two SHM oscillations: Δφ = phase difference (rad)\nv leads x by π/2; a leads x by π (anti-phase)"],
      ]}/>

      <h2 style={S.h2}>SHM Systems — Pendulum and Mass-Spring</h2>
      <p style={S.p}>
        Many physical systems approximate SHM when displaced by small amounts from equilibrium. The two most studied are the simple pendulum and the mass-spring system. Despite their very different physical mechanisms, both obey a = −ω²x and share the same mathematical framework. Their periods depend on different physical quantities — but crucially, neither depends on amplitude (for small oscillations).
      </p>
      <DiagramOscillators/>
      <Table2 rows={[
        ["Simple pendulum period","T = 2π√(L/g)\nL = effective length from pivot to centre of mass; g = gravitational field strength\nValid for θ < ~10°; for larger angles T increases slightly"],
        ["Pendulum ω","ω = √(g/L)\nRestoring force = −mg sinθ ≈ −mgθ for small θ (linear approximation)"],
        ["Mass-spring period","T = 2π√(m/k)\nm = mass (kg), k = spring constant (N/m)\nStiffer spring (larger k) → shorter period"],
        ["Mass-spring ω","ω = √(k/m)\nRestoring force from Hooke's Law: F = −kx"],
        ["Vertical spring","Extension at equilibrium: mg = kx₀\nOscillates about new equilibrium; period unchanged from horizontal case"],
        ["Torsional oscillator","Rotating disc on wire: T = 2π√(I/C)\nI = moment of inertia, C = torsional constant — analogue of mass-spring"],
        ["LC circuit (electrical SHM)","Charge oscillates: Q = Q₀ cos(ωt)\nω = 1/√(LC); L = inductance (H), C = capacitance (F)\nMathematically identical to mass-spring: L↔m, 1/C↔k"],
        ["Molecular vibrations","Atoms in molecules vibrate as mass-spring systems at IR frequencies\nBasis of infrared spectroscopy; ω determines absorption wavelength"],
      ]}/>

      <h2 style={S.h2}>Energy in SHM</h2>
      <p style={S.p}>
        In ideal (undamped) SHM, mechanical energy is continually exchanged between kinetic and potential forms — but the total remains constant. The total energy is proportional to the square of the amplitude, which means doubling the amplitude quadruples the energy stored in the oscillation. This relationship is crucial in wave physics: wave intensity is proportional to amplitude squared.
      </p>
      <DiagramSHMEnergy/>
      <Table2 rows={[
        ["Kinetic energy","EK = ½mv² = ½mω²(A² − x²)\nMaximum at x = 0: EK_max = ½mω²A²"],
        ["Potential energy","EP = ½mω²x²\nMaximum at x = ±A: EP_max = ½mω²A²\nFor spring: EP = ½kx²; for pendulum: EP = mgh (≈ ½mgθ²L)"],
        ["Total energy","E = EK + EP = ½mω²A²  (constant)\nIndependent of position and time in ideal SHM"],
        ["Energy ∝ A²","Doubling amplitude → 4× energy; trebling → 9× energy\nDirect consequence of E = ½mω²A²"],
        ["Energy ∝ ω²","Higher frequency oscillation carries more energy at same amplitude\nKey link to wave intensity: I ∝ A²f²"],
        ["E–x graph shape","EK: inverted parabola (zero at ±A, max at 0)\nEP: upright parabola; sum is horizontal line"],
        ["Power in SHM","Instantaneous power P = Fv = (−mω²x)(ωA cosωt)\nAverage power = 0 in undamped SHM (conservative system)"],
      ]}/>

      <h2 style={S.h2}>Damped Oscillations</h2>
      <p style={S.p}>
        Real oscillating systems always lose energy to their surroundings through friction, air resistance, or internal material damping. The result is that the amplitude decreases over time — a phenomenon called <strong>damping</strong>. The rate of energy loss determines whether the system oscillates at all before returning to equilibrium. Three distinct regimes exist depending on the damping coefficient relative to a critical value.
      </p>
      <DiagramDamping/>
      <Table2 rows={[
        ["Damping force","F_d = −bv  (viscous damping proportional to velocity)\nb = damping coefficient (kg/s); opposes motion at all times"],
        ["Equation of motion","mẍ + bẋ + kx = 0\nSolution depends on whether b² < 4mk, b² = 4mk, or b² > 4mk"],
        ["Light (under) damping","b² < 4mk: oscillations persist; amplitude decays as e^(−bt/2m)\nx(t) = Ae^(−γt) cos(ω't + φ)  where γ = b/2m"],
        ["Damped angular frequency","ω' = √(ω₀² − γ²)  < ω₀\nDamping slightly reduces the oscillation frequency"],
        ["Critical damping","b² = 4mk: fastest return to equilibrium without oscillation\nγ = ω₀; used in car suspension, instrument galvanometers, door closers"],
        ["Heavy (over) damping","b² > 4mk: slow exponential return; no oscillation\nTwo negative real exponents; system takes longer than critically damped case"],
        ["Quality factor Q","Q = ω₀m/b = ω₀/2γ\nNumber of radians of oscillation before energy falls to 1/e of initial\nAlso Q = f₀/Δf (resonance bandwidth)"],
        ["Energy decay","E(t) = E₀ e^(−bt/m) = E₀ e^(−2γt)\nEnergy decays twice as fast as amplitude"],
        ["Logarithmic decrement","Δ = ln(xₙ/xₙ₊₁) = γT' (per cycle)\nUsed to measure damping experimentally from successive peak amplitudes"],
      ]}/>

      <h2 style={S.h2}>Forced Oscillations and Resonance</h2>
      <p style={S.p}>
        When a periodic driving force is applied to an oscillating system, the system is said to undergo <strong>forced oscillations</strong>. The steady-state amplitude of the response depends strongly on the relationship between the driving frequency and the system's natural frequency. At <strong>resonance</strong>, the driving frequency equals the natural frequency and energy transfer is maximised — leading to large amplitude oscillations that can be catastrophic or extraordinarily useful.
      </p>
      <DiagramResonance/>
      <Table2 rows={[
        ["Equation of motion (forced)","mẍ + bẋ + kx = F₀ cos(ω_d t)\nF₀ = driving amplitude, ω_d = driving angular frequency"],
        ["Steady-state amplitude","A = F₀/m / √[(ω₀²−ω_d²)² + (bω_d/m)²]\nPeaks near ω_d = ω₀ (exact resonance peak shifted slightly by damping)"],
        ["Resonance condition","ω_d = ω₀ = √(k/m) → maximum amplitude\nAt resonance: A_res = F₀/(bω₀) = F₀Q/(mω₀²)"],
        ["Phase at resonance","Displacement lags driving force by π/2 at resonance\nBelow resonance: in phase; above resonance: π out of phase"],
        ["Quality factor Q","Q = ω₀/Δω = f₀/Δf  (Δf = half-power bandwidth)\nHigh Q: sharp, tall resonance; high sensitivity but narrow frequency response"],
        ["Barton's pendulums","Set of pendulums on same string; one near-resonant pendulum swings largest\nClassic demonstration of resonance and energy transfer"],
        ["Tacoma Narrows Bridge","Wind-induced vortex shedding at resonant frequency caused collapse (1940)\nFrequency matched fundamental torsional mode of the bridge deck"],
        ["MRI resonance","Hydrogen nuclei precess at Larmor frequency in magnetic field\nRF pulse at exact Larmor frequency (resonance) flips nuclear spin — basis of imaging"],
        ["Electrical resonance","Series LCR circuit: resonance at ω₀ = 1/√(LC)\nQ = ω₀L/R; used in radio tuning, filters, oscillators"],
      ]}/>

      <h2 style={S.h2}>Progressive Waves — Properties and the Wave Equation</h2>
      <p style={S.p}>
        A <strong>progressive (travelling) wave</strong> transfers energy from one location to another through oscillations of the medium (or field). Every point on the wave oscillates in SHM; neighbouring points are slightly out of phase with each other. The wave equation links the spatial and temporal variation of displacement.
      </p>
      <DiagramWaveTypes/>
      <Table2 rows={[
        ["Wave equation (1D)","y(x, t) = A sin(kx − ωt + φ)\nk = 2π/λ (wave number), ω = 2πf, travelling in +x direction"],
        ["Wave speed","v = fλ = ω/k\nDepends only on the medium (not frequency or amplitude in linear media)"],
        ["Wave number k","k = 2π/λ  (rad/m)\nSpatial analogue of angular frequency; describes phase change per unit distance"],
        ["Phase velocity","v_phase = ω/k\nSpeed at which a point of constant phase (e.g. a crest) travels"],
        ["Group velocity","v_group = dω/dk\nSpeed at which the envelope (energy packet) travels in a dispersive medium\nFor non-dispersive media: v_group = v_phase"],
        ["Dispersion","When v depends on frequency: ω = ω(k) is non-linear\nPrism disperses white light; deep water waves are dispersive"],
        ["Intensity","I = Power/Area = ½ρvω²A²  (for mechanical waves)\nIntensity ∝ A² ∝ f² — twice the amplitude means 4× the intensity"],
        ["Inverse square law","I = P/(4πr²) for a point source in 3D free space\nDoubling distance reduces intensity by factor 4"],
        ["Wavefront","Surface of constant phase\nSpherical wavefronts from point source; plane wavefronts far from source (Huygens)"],
        ["Huygens' Principle","Every point on a wavefront acts as a source of secondary spherical wavelets\nEnvelope of wavelets = next wavefront; explains diffraction and refraction"],
      ]}/>

      <h2 style={S.h2}>Transverse and Longitudinal Waves</h2>
      <Table2 rows={[
        ["Transverse wave","Displacement perpendicular to propagation direction\nExamples: all EM waves, water surface waves (approx), string waves, seismic S-waves"],
        ["Longitudinal wave","Displacement parallel to propagation direction\nExamples: sound, ultrasound, seismic P-waves, compression in a slinky"],
        ["Polarisation test","Only transverse waves can be polarised\nExperimental proof that light is transverse (cannot polarise sound)"],
        ["Water waves","Combination: surface particles trace ellipses (neither purely transverse nor longitudinal)\nDeep water: circular orbits; shallow water: increasingly elliptical"],
        ["Seismic P-waves","Primary: longitudinal, fastest (~6 km/s in crust), travel through solids and liquids\nArrives first at seismograph — used to detect earthquake depth and epicentre"],
        ["Seismic S-waves","Secondary: transverse, slower (~3.5 km/s), only travel through solids\nCannot pass through Earth's liquid outer core — proves core is liquid"],
      ]}/>

      <h2 style={S.h2}>Polarisation and Malus's Law</h2>
      <p style={S.p}>
        Polarisation is a property unique to transverse waves. An unpolarised wave has oscillations in all planes perpendicular to the direction of propagation. A <strong>polariser</strong> transmits only the component of the electric field along its transmission axis, producing <strong>plane-polarised</strong> light. When polarised light encounters a second polariser (the analyser) at an angle θ, the transmitted intensity follows <strong>Malus's Law</strong>.
      </p>
      <DiagramPolarisation/>
      <Table2 rows={[
        ["Malus's Law","I = I₀ cos²θ\nθ = angle between polariser and analyser transmission axes\nθ = 0°: full transmission; θ = 90°: zero transmission (crossed polarisers)"],
        ["Brewster's angle","tan θ_B = n₂/n₁\nAt this angle, reflected light from a dielectric surface is fully polarised\nUsed in photography (polarising filters), optics"],
        ["Polarisation by scattering","Sky is partially polarised — sunlight scatters off air molecules\nMost polarised at 90° to the Sun; used by bees and ants for navigation"],
        ["Birefringence","Some crystals (calcite, quartz) split light into two rays with perpendicular polarisations\nOrdinary (o) and extraordinary (e) rays travel at different speeds → double image"],
        ["Wave plates (retarders)","Quarter-wave plate: shifts phase by π/2 — converts linear to circular polarisation\nHalf-wave plate: shifts phase by π — rotates polarisation direction by 2θ"],
        ["LCD screens","Liquid crystal molecules rotate polarisation; voltage applied removes rotation\nLight blocked/transmitted by crossed polarisers — basis of every pixel in a display"],
        ["Optical activity","Some molecules (glucose, proteins) rotate the plane of polarisation\nPolarimetry measures concentration of optically active solutions"],
        ["3D cinema","Two images projected with perpendicular polarisations\nAudience wears glasses with matching polarising filters — each eye sees one image"],
      ]}/>

      <h2 style={S.h2}>Phasor Representation</h2>
      <p style={S.p}>
        A phasor is a rotating vector in a two-dimensional complex plane that elegantly encodes both the amplitude and phase of an oscillation. The projection of the phasor onto the real or imaginary axis gives the instantaneous displacement. Phasors transform the addition of oscillations at the same frequency — which would require trigonometric identities — into straightforward vector addition, making them indispensable in AC circuit analysis, optics, and wave superposition problems.
      </p>
      <DiagramPhasor/>
      <Table2 rows={[
        ["Phasor definition","A vector of length A rotating anticlockwise at ω rad/s\ny(t) = Im[A e^{i(ωt+φ)}] = A sin(ωt + φ)"],
        ["Adding two oscillations","Same frequency: add phasors as vectors → resultant A and phase φ\nA_res² = A₁² + A₂² + 2A₁A₂ cos(Δφ)"],
        ["In-phase (Δφ = 0)","Phasors parallel → A_res = A₁ + A₂  (maximum, constructive)"],
        ["Anti-phase (Δφ = π)","Phasors anti-parallel → A_res = |A₁ − A₂|  (minimum, destructive)"],
        ["General phase difference","tan(φ_res) = (A₁sinφ₁ + A₂sinφ₂)/(A₁cosφ₁ + A₂cosφ₂)"],
        ["AC circuits","Resistor: V in phase with I; Capacitor: V lags I by π/2; Inductor: V leads I by π/2\nPhasor diagram gives impedance Z = V_0/I_0 and phase angle"],
        ["N-source interference","N phasors of equal amplitude A: A_res = A × |Σ e^{inδ}|\nδ = phase difference between adjacent sources"],
      ]}/>

      <h2 style={S.h2}>Superposition, Coherence and Path Difference</h2>
      <p style={S.p}>
        The <strong>principle of superposition</strong> states that when waves overlap, the resultant displacement is the algebraic sum of the individual displacements. For stable interference patterns to be observable, the sources must be <strong>coherent</strong> — maintaining a constant phase difference. The nature of the interference at any point depends on the <strong>path difference</strong> from the two sources to that point.
      </p>
      <Table2 rows={[
        ["Superposition principle","y_total(x,t) = y₁(x,t) + y₂(x,t) + ...\nLinear property; holds for all wave types in linear media"],
        ["Coherence","Two sources are coherent if they have the same frequency and a constant phase difference\nLaser light is coherent; white light has very short coherence length (~μm)"],
        ["Coherence length","L_c = λ²/Δλ  (temporal coherence)\nDistance over which the wave maintains a predictable phase; limits fringe visibility"],
        ["Path difference → phase difference","Δφ = (2π/λ) × Δd\nΔd = path difference (m); links geometry to interference condition"],
        ["Constructive interference","Δd = nλ  (n = 0, ±1, ±2, ...)\nPhase difference = 2nπ; amplitudes add"],
        ["Destructive interference","Δd = (n + ½)λ\nPhase difference = (2n+1)π; amplitudes cancel"],
        ["Young's double slit","Fringe spacing: y = λD/d\nD = slit-to-screen distance, d = slit separation\nFoundation experiment proving the wave nature of light"],
        ["Single slit diffraction","First minimum at: sin θ = λ/a  (a = slit width)\nCentral maximum is twice as wide as subsidiary maxima"],
        ["Diffraction grating","d sin θ = nλ  (d = grating spacing, n = order)\nSharp, bright maxima; resolving power R = nN (N = number of slits)"],
        ["Thin film interference","2nt cos θ = mλ  (constructive, accounting for phase change at boundaries)\nExplains soap bubble colours, anti-reflection coatings, oil films"],
        ["Michelson interferometer","Splits beam into two paths; recombines to produce fringes\nUsed to measure wavelengths, refractive indices, and (scaled up) gravitational waves (LIGO)"],
      ]}/>

      <h2 style={S.h2}>The Electromagnetic Spectrum</h2>
      <p style={S.p}>
        Electromagnetic waves are transverse waves consisting of oscillating electric and magnetic fields perpendicular to each other and to the direction of propagation. They require no medium and travel at c = 3 × 10⁸ m/s in a vacuum. The EM spectrum spans over 20 orders of magnitude in frequency, from radio waves to gamma rays — all governed by the same wave equations and differing only in frequency (and therefore energy per photon: E = hf).
      </p>
      <Table2 rows={[
        ["Radio waves","f: 3 Hz – 300 MHz;  λ: 1 mm – 100,000 km\nBroadcast radio and TV, radar, MRI, mobile communications"],
        ["Microwaves","f: 300 MHz – 300 GHz;  λ: 1 mm – 1 m\nMobile networks (4G/5G), Wi-Fi, microwave ovens (2.45 GHz), satellite comms, weather radar"],
        ["Infrared (IR)","f: 300 GHz – 430 THz;  λ: 700 nm – 1 mm\nHeat radiation, thermal imaging, fibre optic comms, TV remotes, IR spectroscopy"],
        ["Visible light","f: 430 – 770 THz;  λ: 390 – 700 nm\nOnly EM range detected by human eye; ROYGBIV (red → violet = increasing frequency)"],
        ["Ultraviolet (UV)","f: 770 THz – 30 PHz;  λ: 10 – 400 nm\nCauses sunburn, fluorescence; UV-A/B/C; absorbed by ozone layer (UV-C and UV-B)"],
        ["X-rays","f: 30 PHz – 30 EHz;  λ: 0.01 – 10 nm\nMedical imaging, crystallography (XRD), airport security, cancer radiotherapy"],
        ["Gamma rays","f: > 30 EHz;  λ: < 0.01 nm\nNuclear decay, PET scans, sterilisation; most penetrating; stopped by dense lead"],
        ["Photon energy","E = hf = hc/λ\nh = 6.63 × 10⁻³⁴ J·s; gamma photon ~MeV; radio photon ~neV"],
        ["EM wave in medium","Speed: v = c/n  (n = refractive index)\nλ_medium = λ_vacuum/n; frequency unchanged on entering a medium"],
        ["Refractive index","n = c/v = sin θ_i / sin θ_r  (Snell's Law)\nMeasure of how much slower light travels in a medium"],
        ["Total internal reflection","Occurs when θ_i > θ_c = arcsin(n₂/n₁) for n₁ > n₂\nBasis of optical fibres, prism reflectors, diamonds"],
        ["Dispersion in medium","n varies with wavelength → different colours refract by different amounts\nPrism splits white light; rainbows; chromatic aberration in lenses"],
      ]}/>

      <h2 style={S.h2}>Coupled Oscillators and Normal Modes</h2>
      <p style={S.p}>
        When two or more oscillators are linked by a coupling (a spring, a string, or any restoring interaction), the system's behaviour becomes richer than individual oscillators. The coupled system has characteristic <strong>normal modes</strong> — patterns of motion in which all parts oscillate at the same frequency. Any general motion is a superposition of normal modes, and <strong>energy can be transferred</strong> back and forth between oscillators through the coupling — a phenomenon called <strong>mode beating</strong>.
      </p>
      <Table2 rows={[
        ["Normal modes","Patterns in which all parts of the system oscillate at the same frequency with fixed relative phases\nA system with N degrees of freedom has N normal modes"],
        ["Two coupled pendulums (in-phase mode)","Both pendulums swing together in the same direction\nFrequency = ω₀ = √(g/L); coupling spring has no effect — not stretched"],
        ["Two coupled pendulums (anti-phase mode)","Pendulums swing in opposite directions\nFrequency = √(ω₀² + 2κ/m)  where κ = coupling spring constant; higher than ω₀"],
        ["Mode beating","System excited in one pendulum only: energy transfers completely to the other, then back\nBeat period T_beat = 2π/(ω₂ − ω₁) — analogue of acoustic beats"],
        ["Normal modes of strings","Standing waves are the normal modes of a stretched string\nFrequencies: fₙ = n × v/2L  (n = 1, 2, 3, ...)"],
        ["3D lattice vibrations (phonons)","Normal modes of crystal lattice → quantised as phonons\nAcoustic and optical branches; determines heat capacity and thermal conductivity"],
        ["Coupled LC circuits","Electrical analogue: capacitively or inductively coupled LC circuits\nSame mathematics; used in filter design and RF coupling networks"],
        ["Avoided crossing","When two coupled oscillators have similar natural frequencies, their mode frequencies repel\nA fundamental quantum mechanical phenomenon also seen in classical coupled systems"],
      ]}/>

      <h2 style={S.h2}>Wave Intensity and Power</h2>
      <Table2 rows={[
        ["Intensity definition","I = P/A  (W/m²)\nPower flowing through unit area perpendicular to wave direction"],
        ["Intensity and amplitude","I ∝ A²  (for any wave type)\nDoubling amplitude → 4× intensity; energy ∝ A²"],
        ["Intensity and frequency","I ∝ f²  (mechanical waves at same amplitude)\nI = ½ρvω²A²  — hence ω² = (2πf)² factor"],
        ["3D spreading (spherical)","I = P/(4πr²) — inverse square law\nDoubling distance: I drops to ¼; tripling: drops to 1/9"],
        ["2D spreading (cylindrical)","I = P/(2πrL) ∝ 1/r\nCylindrical waves (e.g. from a long straight source) decay more slowly"],
        ["1D wave (no spreading)","I = constant along direction of travel (no geometric spreading)\nWave in a tube; plane wave in free space"],
        ["Absorption","I = I₀ e^(−μx)  (Beer-Lambert law)\nμ = absorption coefficient (m⁻¹); depends on medium and wave frequency"],
        ["Radiation pressure","EM waves carry momentum: p = E/c per photon\nPressure P = I/c (absorbing surface); P = 2I/c (reflecting surface)\nBasis of solar sails; measurable with laser tweezers"],
      ]}/>

      <InfoBox title="Key Formulae — Oscillations and Waves" items={[
        "SHM condition: a = −ω²x;   displacement: x = A cos(ωt + φ)",
        "Speed in SHM: v = ω√(A² − x²);   max speed: v_max = Aω",
        "Total energy: E = ½mω²A²   (constant, proportional to A²)",
        "Simple pendulum: T = 2π√(L/g);   ω = √(g/L)",
        "Mass-spring: T = 2π√(m/k);   ω = √(k/m)",
        "LC circuit (electrical SHM): ω = 1/√(LC)",
        "Damped amplitude: x_max(t) = Ae^(−γt)  where γ = b/2m",
        "Quality factor: Q = ω₀/2γ = f₀/Δf",
        "Wave equation: y(x,t) = A sin(kx − ωt);   v = fλ = ω/k",
        "Intensity: I = ½ρvω²A²;   inverse square law: I = P/(4πr²)",
        "Phase difference from path difference: Δφ = (2π/λ) × Δd",
        "Young's fringes: y = λD/d;   diffraction grating: d sinθ = nλ",
        "Malus's Law: I = I₀ cos²θ",
        "Photon energy: E = hf = hc/λ;   c = 3 × 10⁸ m/s",
        "Refractive index: n = c/v = sinθ_i/sinθ_r (Snell's Law)",
      ]}/>
    </div>
  );
}